import isEmpty from 'hs-lodash/isEmpty';
import { getPrefilledSignupData } from '../flow-settings/settingsSelectors';
import { bulkUpdate, prefillDataStored, stampPrefilled } from '../store/signup-data/action-creators';
export const prefillSignupDataFromUrl = () => dispatch => {
  const prefills = getPrefilledSignupData();

  if (!isEmpty(prefills)) {
    dispatch(bulkUpdate(prefills));
    dispatch(stampPrefilled(prefills));
    dispatch(prefillDataStored());
  }
};